
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as HelpCenterIconComponent } from "./help-center-icon.svg";

export const HelpCenterIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <HelpCenterIconComponent {...props} />;
};
